import {
  GET_IME_ARTICLES,
  IME_ARTICLE_ERROR,
  UPDATE_IME_ARTICLE_LIKES,
  DELETE_IME_ARTICLE,
  ADD_IME_ARTICLE,
  GET_IME_ARTICLE,
  ADD_IME_ARTICLE_COMMENT,
  ADD_IME_ARTICLE_REPLY,
  REMOVE_IME_ARTICLE_COMMENT,
} from '../actions/types';

const initialState = {
  imearticles: [],
  imearticle: null,
  imearticleloading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_IME_ARTICLES:
      return {
        ...state,
        imearticles: payload,
        imearticleloading: false,
      };
    case GET_IME_ARTICLE:
      return {
        ...state,
        imearticle: payload,
        imearticleloading: false,
      };
    case ADD_IME_ARTICLE:
      return {
        ...state,
        imearticles: [payload, ...state.imearticles],
        imearticleloading: false,
      };
    case DELETE_IME_ARTICLE:
      return {
        ...state,
        imearticles: state.imearticles.filter(
          (imearticle) => imearticle._id !== payload
        ),
        imearticleloading: false,
      };
    case IME_ARTICLE_ERROR:
      return {
        ...state,
        error: payload,
        imearticleloading: false,
      };
    case UPDATE_IME_ARTICLE_LIKES:
      return {
        ...state,
        imearticles: state.imearticles.map((imearticle) =>
          imearticle._id === payload.id
            ? { ...imearticle, likes: payload.likes }
            : imearticle
        ),
        imearticleloading: false,
      };
    case ADD_IME_ARTICLE_COMMENT:
      return {
        ...state,
        imearticle: { ...state.imearticle, comments: payload },
        imearticleloading: false,
      };
    case REMOVE_IME_ARTICLE_COMMENT:
      return {
        ...state,
        imearticle: {
          ...state.imearticle,
          comments: state.imearticle.comments.filter(
            (comment) => comment._id !== payload
          ),
        },
        imearticleloading: false,
      };
    case ADD_IME_ARTICLE_REPLY:
      return {
        ...state,
        imearticle: { ...state.imearticle, replies: payload },
        imearticleloading: false,
      };
    default:
      return state;
  }
}
